import { useOnImportacaoCnesAddedSubscription, useOnImportacaoCnesUpdatedSubscription } from 'graphql/hooks.generated'

interface ImportacaoCnesListenerProps {
  municipio: ID
  onImportacaoAdded(): void
}

export const ImportacaoCnesListener = (props: ImportacaoCnesListenerProps) => {
  const { municipio, onImportacaoAdded } = props
  useOnImportacaoCnesUpdatedSubscription({ variables: { municipio } })
  useOnImportacaoCnesAddedSubscription({
    variables: { municipio },
    onSubscriptionData: () => onImportacaoAdded(),
  })
  return null
}
